/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import { DirectoryImportCollectionClass } from 'client/store/modules/collections/DirectoryImportCollection';
import { ImportUsersConsts } from 'client/util/Constants';
import { mixin } from 'lodash';
import ImportUsersMixin, { updateState } from 'client/store/mixins/ImportUsersMixin';
import O365ImportApi from 'client/api/v2/O365ImportApi';

const { source } = ImportUsersConsts;

export const processUsers = users => users.map((user) => {
  const systemUser = {
    email: user.userPrincipalName,
    firstname: user.givenName,
    lastname: user.surname,
    username: `${user.userPrincipalName.split('@')[0]}`,
  };

  return systemUser;
});

export class O365ImportCollectionClass extends DirectoryImportCollectionClass {
  /**
   * Override method from base class to add O365 specific fields to the Vuex
   * module entities and features.
   */
  extractModule() {
    const module = super.extractModule();

    mixin(module.actions, ImportUsersMixin.actions);
    mixin(module.getters, ImportUsersMixin.getters);
    mixin(module.mutations, ImportUsersMixin.mutations);

    module.actions.fetchCollection = (...params) => this.fetchCollection(...params);
    module.actions.importSelectedUsers = (...params) => this.importSelectedUsers(...params);
    module.actions.setBulkImportLimit = (...params) => this.setBulkImportLimit(...params);
    module.actions.setO365Id = (...params) => this.setO365Id(...params);

    module.getters.getErrorPollingImportResults = (...params) => this
      .getErrorPollingImportResults(...params);

    module.mutations.SET_BULK_IMPORT_LIMIT = (...params) => this.SET_BULK_IMPORT_LIMIT(...params);
    module.mutations.SET_O365_ID = (...params) => this.SET_O365_ID(...params);

    return module;
  }

  // ----------------------------------------------------------------------------------------------
  // State
  // ----------------------------------------------------------------------------------------------

  getInitialState() {
    const state = updateState(super.getInitialState());
    return state;
  }

  // ----------------------------------------------------------------------------------------------
  // Actions
  // ----------------------------------------------------------------------------------------------

  /**
   * Override method from ImportUsersMixin to specify a custom method to process the users prior to
   * importing them into JumpCloud.
   */
  importSelectedUsers(context) {
    return ImportUsersMixin.actions.importSelectedUsers(context, processUsers, source.o365);
  }

  setBulkImportLimit({ commit }, bulkImportLimit) {
    commit('SET_BULK_IMPORT_LIMIT', bulkImportLimit);
  }

  setO365Id({ commit }, { o365Id }) {
    commit('SET_O365_ID', { o365Id });
  }

  // ----------------------------------------------------------------------------------------------
  // Getters
  // ----------------------------------------------------------------------------------------------

  getErrorPollingImportResults(state = { features: {} }) {
    return state.features.errorPollingImportResults;
  }

  // ----------------------------------------------------------------------------------------------
  // Mutations
  // ----------------------------------------------------------------------------------------------

  /**
   * When sorting or searching a soft reset is performed. This preserves the
   * selected and modified items. This allows the admin user's selection and
   * changes to persist, and not be lost, when searching and sorting.
   */
  RESET_COLLECTION(state = {
    features: {},
    entities: {},
  }, { soft = false } = {}) {
    super.RESET_COLLECTION(state, { soft });
    const initialState = this.getInitialState();
    state.entities.o365Id = initialState.entities.o365Id;
    state.features.jobId = initialState.features.jobId;
  }

  SET_BULK_IMPORT_LIMIT(state = { features: {} }, bulkImportLimit = false) {
    state.features.bulkImportLimit = bulkImportLimit;
  }

  SET_O365_ID(state = { entities: { o365Id: {} } }, { o365Id }) {
    state.entities.o365Id = o365Id;
    this.Api.setO365Id(o365Id);
  }
}

export default new O365ImportCollectionClass(O365ImportApi, 'id', '').extractModule();
